import { useState } from 'react';
import { useSelector } from 'react-redux';
import { Menu, MenuItem } from '@mui/material';
import { formatCurrency } from '../../../../../utils/global';
import CustomTooltip from '../../../../common-components/CustomTooltip/CustomTooltip';
import KeyboardDownIcon from '@mui/icons-material/KeyboardArrowDownRounded';
import CheckIcon from '@mui/icons-material/CheckRounded';
import closeIcon from '../../../../../images/icons/close.svg';
import addIcon from '../../../../../images/icons/add.svg';
import minusIcon from '../../../../../images/icons/minus.svg';
import addNewVariantIcon from '../../../../../images/icons/add-new-variant.svg';
import XIcon from '../../../../Icons/icons/XIcon';
import ShortString from '../../../../common-components/ShortString/ShortString';

export default function VariantSelectionCard({
  id,
  name,
  variants,
  image,
  options,
  price,
  removeProduct,
  quantities,
  setQuantities,
  allOptions,
  setAllOptions,
  productIndex,
  cloneObject,
  disabledQuantities = false,
}) {
  const [currentOptionDropdown, setCurrentOptionDropdown] = useState(null);
  const [showOptionsDropdown, setShowOptionsDropdown] = useState(null);
  const [quantity, setQuantity] = useState(1);
  const { userDetails } = useSelector((state) => state.user);

  const handleQuantityChange = (action) => {
    setQuantity((prev) => {
      const updatedQuantity = action === 'add' ? prev + 1 : prev - 1;
      setQuantities({ ...quantities, [id]: updatedQuantity });
      return updatedQuantity;
    });
  };

  return (
    <div className="select-variant-card">
      <div className="top-image-container">
        <img src={image} alt={name} />
      </div>
      <div className="bottom-details-container">
        <div className="product-name-container">
          <div>
            <h3>{name}</h3>
            <h4>{formatCurrency(Number(price || variants?.[0]?.price), userDetails?.defaultCurrency)}</h4>
          </div>
          <XIcon alt="" onClick={() => removeProduct(id)} style={{ marginTop: 6, cursor: 'pointer' }} />
        </div>
        <div className="variant-option-list">
          {options?.[0]?.options?.[0] !== 'Default Title' &&
            options?.map((option, index) => {
              return (
                <div key={option.id} className="text-input-container">
                  <div className="text-field-wrapper">
                    <div
                      className="label-container"
                      style={{
                        display: 'flex',
                        alignItems: 'flex-start',
                        justifyContent: 'space-between',
                        width: '100%',
                      }}>
                      <label>
                        <ShortString name={`Select ${option?.name} *`} />
                      </label>
                      {index === 0 && (
                        <CustomTooltip title="Add new variant" arrow placement="top">
                          <img
                            src={addNewVariantIcon}
                            alt=""
                            style={{ cursor: 'pointer' }}
                            onClick={() => cloneObject(productIndex)}
                          />
                        </CustomTooltip>
                      )}
                    </div>
                    <div className="text-field-inner-wrapper">
                      <div
                        className="dropdown-selected"
                        onClick={(e) => {
                          setShowOptionsDropdown(e.currentTarget);
                          setCurrentOptionDropdown(index);
                        }}
                        style={{ width: '100%' }}>
                        <span style={{ color: '#667085' }}>
                          <ShortString
                            name={allOptions[id]?.[`option${index + 1}`] || `Choose ${option?.name}`}
                            stringLength={16}
                          />
                        </span>
                        <div
                          style={{
                            transform: Boolean(currentOptionDropdown === index) && 'rotate(180deg)',
                            transition: 'all 0.2s ease-in-out',
                          }}>
                          <KeyboardDownIcon />
                        </div>
                      </div>
                      <Menu
                        anchorEl={showOptionsDropdown}
                        open={Boolean(currentOptionDropdown === index)}
                        PaperProps={{ sx: { width: '215px' } }}
                        onClose={() => {
                          setShowOptionsDropdown(null);
                          setCurrentOptionDropdown('');
                        }}>
                        {option?.options?.map((v, i) => (
                          <MenuItem
                            disableRipple
                            key={i}
                            onClick={() => {
                              setAllOptions({ ...allOptions, [id]: { ...allOptions[id], [`option${index + 1}`]: v } });
                              setShowOptionsDropdown(null);
                              setCurrentOptionDropdown('');
                            }}
                            sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <span
                              style={{
                                fontSize: 14,
                                color: options[`option${index + 1}`] === v ? '#7357e9' : '#353535',
                              }}>
                              {v}
                            </span>
                            {options[`option${index + 1}`] === v && (
                              <CheckIcon sx={{ color: '#7357e9', fontSize: 20 }} />
                            )}
                          </MenuItem>
                        ))}
                      </Menu>
                    </div>
                  </div>
                </div>
              );
            })}
        </div>
        {!disabledQuantities && (
          <div className="text-field-wrapper quantity-selector">
            <label>Quantity*</label>
            <div className="quantity-container">
              <button disabled={quantity === 1} onClick={() => handleQuantityChange('sub')}>
                <img src={minusIcon} alt="" />
              </button>
              <p>{quantity}</p>
              <button disabled={quantity === 20} onClick={() => handleQuantityChange('add')}>
                <img src={addIcon} alt="" />
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
